<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Users</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-4">
            <label class="dado__label">Role</label>
            <vue-select v-model="filters.role" :options="rolesFilter" @change="onFilter"></vue-select>
          </div>
          <div class="col-12 col-md-4">
            <label class="dado__label">Search</label>
            <div class="search">
              <input type="text" v-model="filters.name" placeholder="Type here..." class="search__field"/>
              <span class="form__del" :class="{'d-block': filters.name.length}" @click="onClearName"></span>
              <button type="submit" class="search__btn" @click="onFilter"></button>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div @click="onShowCreateModal()" class="btn__add">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 14V1M14 7.5H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Add User
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="dado__array">
          <div class="dado__bred">
            <table class="table">
              <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th">ID</th>
                <th class="table__th">Name</th>
                <th class="table__th">Role</th>
                <th class="table__th">Email</th>
                <th class="table__th">Phone Number</th>
                <th class="table__th"></th>
              </tr>
              </thead>
              <tbody class="table__tbody">
              <tr class="table__tr" v-for="user in getUsers">
                <td class="table__td">{{ user.id }}</td>
                <td class="table__td">{{ user.name }}</td>
                <td class="table__td">
                  <div v-for="role in user.roles">{{ role.name }}</div>
                </td>
                <td class="table__td">{{ user.email }}</td>
                <td class="table__td">{{ user.phone }}</td>
                <td class="table__td col_manage">
                  <div class="d-flex">
                    <div @click="onShowEditModal(user)"
                         class="table__pick edit cursor-pointer"
                         v-tooltip="'Edit'">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path d="M12.9214 8.79458C12.7289 8.79458 12.5728 8.95066 12.5728 9.14325V12.2391C12.5721 12.8166 12.1042 13.2846 11.5268 13.2851H1.74336C1.16587 13.2846 0.698026 12.8166 0.697345 12.2391V3.15303C0.698026 2.57568 1.16587 2.10769 1.74336 2.10701H4.83919C5.03178 2.10701 5.18787 1.95093 5.18787 1.75834C5.18787 1.56589 5.03178 1.40967 4.83919 1.40967H1.74336C0.780972 1.41076 0.0010896 2.19064 0 3.15303V12.2392C0.0010896 13.2016 0.780972 13.9815 1.74336 13.9826H11.5268C12.4892 13.9815 13.269 13.2016 13.2701 12.2392V9.14325C13.2701 8.95066 13.114 8.79458 12.9214 8.79458Z"
                                fill="white"/>
                          <path d="M13.1332 0.512552C12.5204 -0.100213 11.527 -0.100213 10.9142 0.512552L4.69366 6.73309C4.65103 6.77572 4.62025 6.82857 4.60418 6.88659L3.78616 9.83982C3.75252 9.9609 3.78671 10.0906 3.87551 10.1795C3.96445 10.2683 4.09411 10.3025 4.21519 10.269L7.16842 9.45083C7.22644 9.43476 7.27929 9.40398 7.32192 9.36134L13.5423 3.14067C14.1541 2.5275 14.1541 1.53487 13.5423 0.921698L13.1332 0.512552ZM5.45339 6.95973L10.5444 1.86856L12.1863 3.51046L7.09515 8.60162L5.45339 6.95973ZM5.12542 7.61785L6.43716 8.92973L4.6227 9.43244L5.12542 7.61785ZM13.0493 2.64763L12.6795 3.01741L11.0375 1.37538L11.4074 1.0056C11.7477 0.665233 12.2996 0.665233 12.64 1.0056L13.0493 1.41474C13.3891 1.75552 13.3891 2.30699 13.0493 2.64763Z"
                                fill="white"/>
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="14" height="14" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div @click="onDelete(user)"
                         class="table__pick delete cursor-pointer"
                         v-tooltip="'Delete'">
                      <svg class='table__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                              fill="white"/>
                        <path d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                              fill="white"/>
                        <path d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                              fill="white"/>
                        <path d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                              fill="white"/>
                      </svg>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
                  v-if="pages > 1"
                  :page-count="pages"
                  :click-handler="onChangePage"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :prev-class="'pagination__prev'"
                  :next-class="'pagination__next'"
                  :page-class="'pagination__item'"
                  :active-class="'active'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: "Users",
    data() {
      return {
        filters: {
          role: 'All',
          name: '',
          page: 1
        },
        rolesFilter: [
          'All',
          'Admin',
          'Partner Organisation'
        ],
      }
    },
    computed: {
      ...mapGetters([
        'getRoles',
        'getUsers',
        'getUsersPagination',
        'getRolesOptions',
      ]),
      pages() {
        return Math.ceil(this.getUsersPagination.count / this.getUsersPagination.per_page)
      }
    },
    mounted() {
      this.setUsersFilters(this.filters)
      this.queryUsers()
      this.queryPartners()
    },
    methods: {
      ...mapActions([
        'showModal',
        'queryUsers',
        'destroyUser',
        'queryPartners'
      ]),
      ...mapMutations([
        'setUsersFilters',
      ]),
      onClearName() {
        this.filters.name = ''
        this.onFilter()
      },
      onFilter() {
        this.setUsersFilters(this.filters)
        this.queryUsers()
      },
      onChangePage(page) {
        this.filters.page = page
        this.onFilter()
      },
      onShowCreateModal() {
        this.showModal({modal: 'ModalUser', data: {}})
      },
      onShowEditModal(user) {
        this.showModal({modal: 'ModalUser', data: user})
      },
      onDelete(user) {
        this.$confirm({
          message: 'Delete user ' + user.name + '?',
          callback: confirm => {
            if (confirm)
              this.destroyUser(user.id)
          }
        })
      }
    }
  }
</script>

<style>

</style>